import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "@/stores";

const actions = () => ({
  async createCompany(payload) {
    const res = await api.post("/api/company/create", payload);

    if (payload.image) {
      const formData = new FormData();
      formData.append("file", payload.image);

      await api.post(`/api/files/${res.id}/upload/logo`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }

    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "The company has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });

    router.push("/company/overview");
  },

  async editCompany(payload) {
    await api.post(`/api/company/${payload.id}`, payload.data);

    if (payload.data.image) {
      const formData = new FormData();
      formData.append("file", payload.data.image);

      await api.post(`/api/files/${payload.id}/upload/logo`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }

    const newData = await this.getCompany({ id: payload.id });

    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });

    return newData;
  },

  async downloadExcel(payload) {
    try {
      const response = await api.get("/api/company/overview/export", {
        params: payload,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  },

  async getCompanyOverview(payload) {
    const res = await api.get("/api/company/overview", {
      params: payload,
    });
    this.overview = res.data.content;
    this.pagination.totalItems = res.data.totalElements;
    this.pagination.cuurentPage = res.data.number + 1;
    this.pagination.pageCount = res.data.totalPages;
  },

  async getCompany(payload) {
    const res = await api.get(`/api/company/${payload.id}`);
    return res.data;
  },

  resetAction() {
    this.filters.keyword = null;
    this.filters.advanced = {
      name: null,
      branch: null,
      responsible: null,
      talentPlatformProfile: null,
      pipeline: [],
      date: [],
      companySector: [],
    };
  },
});

export default actions;
